<script lang="ts">
	export let to = '';
</script>

<a class="tagLink px-tag" href={to}>
	<span class="px-tag-hash">#</span>
	<slot />
</a>

<style>
	.tagLink {
		display: inline-block;
		block-size: 18px;
		margin-inline-end: var(--gutterSmall);
		color: var(--tagColor);
		font-size: 1.1rem;
		font-weight: 400;
		letter-spacing: 0.4px;
		line-height: 1.8rem;
		word-wrap: break-word;
		vertical-align: top;
	}

	.tagLink:last-child {
		margin-inline-end: 0;
	}
</style>
